<template>
  <!-- 官网顶部导航：左侧 Logo，右侧栏目 -->
  <header class="site-header">
    <div class="container header-inner">
      <!-- Logo：后台配置了 LOGO 图片则显示图片，否则显示默认图标 -->
      <router-link to="/" class="logo">
        <img v-if="logo" class="logo-img" :src="logo" :alt="siteName || '站点 LOGO'">
        <i v-else class="el-icon-office-building logo-icon"></i>
        <span class="logo-text">{{ siteName || '示例科技' }}</span>
      </router-link>

      <!-- 栏目导航 -->
      <nav class="nav">
        <router-link to="/" class="nav-item" :class="{ active: activePath === '/' }">首页</router-link>
        <router-link to="/products" class="nav-item" :class="{ active: activePath === '/products' }">产品中心</router-link>
        <router-link to="/news" class="nav-item" :class="{ active: activePath === '/news' }">新闻动态</router-link>
        <router-link to="/about" class="nav-item" :class="{ active: activePath === '/about' }">关于我们</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    // 站点名称：来自后台「站点配置」，App.vue 传入；为空时显示兜底文案
    siteName: { type: String, default: '' },
    // LOGO 图片地址：后台「站点配置」上传；为空时显示默认图标
    logo: { type: String, default: '' }
  },
  computed: {
    // 当前属于哪个一级栏目，用于高亮导航
    // 例如 /products/3 详情页也应当高亮「产品中心」
    activePath() {
      const path = this.$route.path
      if (path.startsWith('/products')) return '/products'
      if (path.startsWith('/news')) return '/news'
      if (path.startsWith('/about')) return '/about'
      return '/'
    }
  }
}
</script>

<style scoped>
.site-header {
  position: sticky;   /* 滚动时导航固定在顶部 */
  top: 0;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}
.header-inner {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  display: flex;
  align-items: center;
  color: #1f2d3d;
}
.logo-icon {
  font-size: 26px;
  color: #1677ff;
  margin-right: 8px;
}
.logo-img {
  height: 40px;
  width: auto;
  margin-right: 8px;
}
.logo-text {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
}
.nav {
  display: flex;
  gap: 8px;
}
.nav-item {
  padding: 8px 18px;
  font-size: 15px;
  color: #606266;
  border-radius: 4px;
  transition: all 0.2s;
}
.nav-item:hover { color: #1677ff; }
/* 当前栏目高亮 */
.nav-item.active {
  color: #ffffff;
  background: #1677ff;
}
</style>
